import { Plugins } from '@capacitor/core';
const GoogleAuthPlugin = Plugins.GoogleAuth;
export class GoogleAuth {
    constructor() {
        this.signIn = GoogleAuthPlugin.signIn;
        this.refresh = GoogleAuthPlugin.refresh;
        this.signOut = GoogleAuthPlugin.signOut;
    }
}
//# sourceMappingURL=plugin.js.map